import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { push } from 'react-router-redux'

import Secondary from '../../layouts/Secondary';

import BudgetAreaTable from '../../components/common/tables/BudgetAreaTable';
import Divide from '../../components/common/divide/Divide';
import SpendingAreaCard from '../../components/common/cards/spending-area-card/SpendingAreaCard';
import Notification from '../../components/common/notification/Notification';
import IncomeAreasSection from '../../components/sections/income-areas-section/IncomeAreasSection';
import BudgetSuccessModal from '../../components/common/modal/BudgetSuccessModal';
import BudgetFailureModal from '../../components/common/modal/BudgetFailureModal';
import RangeInput from '../../components/common/range/RangeInput';
import BudgetTotalBar from '../../components/budget-total-bar/BudgetTotalBar';
import SubmitBudgetForm from '../../components/forms/SubmitBudgetForm';
import NewsItemSummary from '../../components/sections/news-item-summary/NewsItemSummary';

import { Cell, Grid } from '../../components/layout';

import lockedRangeInputImage from '../../assets/images/locked-range.png';

import {
  budgetActions,
  newsActions
} from '../../reducks'

import { smallNumber } from '../../helpers/number';
import Modal from '../../components/common/modal/Modal';

class SetYourBudget extends Component {
  state = {
    barColor: this.props._budget.council.value_tax / this.props._budget.council.max_tax,
    fixed: false,
    spendingAreaInfoBlocks: [],
    capitalTriggered: false,
    isCouncilInfoModalActive: false,
    giveUpReason: '',
    startTime: 0,
  }

  get spendingAreas() {
    return this.props._budget.spending_areas;
  }

  getPotentialImpacts = (cons, value, max) => {
    if (cons && cons.length > 0) {
      cons = cons.filter((item) => {
        const total = max - value;
        return item.to <= total || total >= item.from;
      });
    }
    return cons;
  }

  componentDidMount() {
    window.scroll(0, 0);

    window.addEventListener('scroll', () => {
      const scrollAmount = document.documentElement.scrollTop || document.body.scrollTop;

      if (this.fixedSection) {
        if (scrollAmount > this.fixedSection.offsetTop) {
          if (!this.state.fixed) {
            this.setState({ fixed: true })
          }
        } else {
          if (this.state.fixed) {
            this.setState({ fixed: false })
          }
        }
      }
    });

    // Call the started action
    this.props.logUserStartingAction();

    let spendingAreasInfoContent = this.spendingAreas.map(item => {
      return {
        ...item,
        isInfoCardActive: false,
        isImpactsCardActive: false,
        active: false,
      }
    });

    const timeWithMilliseconds = new Date().getTime()
    const timeWithoutMilliseconds = Math.floor(timeWithMilliseconds / 1000);

    this.setState({
      spendingAreaInfoBlocks: spendingAreasInfoContent,
      startTime: timeWithoutMilliseconds,
    });
  }

  componentDidUpdate(nextProps, prevProps) {
    if (nextProps._budget.current_total !== this.props._budget.current_total) {
      if (smallNumber(this.props._budget.initial_total - this.props._budget.current_total) === '28.0m') {

        if (navigator.userAgent.indexOf('Edge') >= 0) {
          return;
        } else {
          const showButton = false;
          this.props.showBudgetSuccessModalAction(showButton);
        }

      }
    }
  }

  toggleInfoCard = (slug, cardType) => {
    const index = this.state.spendingAreaInfoBlocks.findIndex(item => item.slug === slug);
    const blocks = [...this.state.spendingAreaInfoBlocks];

    if (cardType === 'info') {
      blocks[index].isInfoCardActive = !blocks[index].isInfoCardActive;
    } else if (cardType === 'impacts') {
      blocks[index].isImpactsCardActive = !blocks[index].isImpactsCardActive;
    }

    if (blocks[index].isInfoCardActive || blocks[index].isImpactsCardActive) {
      window.scroll(0, document.getElementById('service-areas-section').offsetTop - 50);
    }

    this.setState({
      spendingAreaInfoBlocks: blocks,
    });
  }

  toggleCapitalInfo = () => {
    this.setState({
      capitalTriggered: !this.state.capitalTriggered,
    });
  }

  toggleCouncilModal = () => {
    this.setState({
      isCouncilInfoModalActive: !this.state.isCouncilInfoModalActive,
    });
  }

  // Assign the payload to our local state
  assignPayload = (payload) => {
    if ((this.props._budget.initial_total - this.props._budget.current_total) !== 28000000) {
      this.props.showBudgetFailureModalAction();
    } else {
      this.setState({
        formPayload: payload,
      }, () => {
        this.stopTimerAndSubmitPayload();
      });
    }
  }

  stopTimerAndSubmitPayload = () => {
    const data = {
      ...this.state.formPayload,
      started_at: this.state.startTime,
    }

    this.props.saveAction(data);
  }

  setGiveUpReason = (reason) => {
    this.setState({
      giveUpReason: reason,
    });
  }

  setGiveUpStatus = () => {
    this.setState({
      giveUpStatus: true,
    })
  }

  render() {
    const { fixed, spendingAreaInfoBlocks } = this.state;
    const {
      _budget,
      _news,
      changeCouncilBudgetAction,
      changeCouncilCategoryAction,
    } = this.props;

    /**
     * Set the width of the current target bar.
     * The width should cap at 100% when the current total is 20 million or greater.
     */
    const currentTargetPercentage = ((_budget.initial_total - _budget.current_total) / 28000000) * 100;
    const savingsTargetWidthValue = currentTargetPercentage < 100 ? currentTargetPercentage : 100;

    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    return (
      <Secondary>
        {
          this.props._budget.showBudgetSuccessModal &&
          <BudgetSuccessModal
            showActions={this.props._budget.showButton}
            handleSubmit={() => this.stopTimerAndSubmitPayload()}
            handleClose={this.props.hideBudgetSuccessModal} />
        }

        {
          this.props._budget.showBudgetFailureModal &&
          <BudgetFailureModal handleClose={this.props.hideBudgetFailureModal} />
        }

        {
          this.props._budget.showRefurendumModal &&
          <Modal handleClose={() => this.props.toggleRefurendumModal()}>
            <i className="c-modal__budget-icon fas fa-info" />
            <h2 className="c-modal__title">Council Tax and Adult Social Care Precept</h2>
            <p>
              When allocating funding to councils, government assumes councils will increase Council Tax by up to 3%. It also assumes councils will apply a 2% precept to be spent on adult social care. A council must hold a referendum costing around £250,000 if it wants to go above these levels.
            </p>
          </Modal>
        }

        {
          this.state.isCouncilInfoModalActive &&
          <Modal handleClose={() => this.toggleCouncilModal()}>
            <i className="c-modal__budget-icon fas fa-info" />
            <h2 className="c-modal__title">Council Tax and Adult Social Care Precept</h2>
            <p>
              When allocating funding to councils, government assumes councils will increase Council Tax by up to 3%. It also assumes councils will apply a 2% precept to be spent on adult social care. A council must hold a referendum costing around £250,000 if it wants to go above these levels.
            </p>
          </Modal>
        }

        <div className="l-container l-container--padded syb-top-area">
          <Grid>
            <Cell size={{ desktop: '12', tablet: '7', phone: '6' }}>
              <h1 className="m-0">Set Your Budget</h1>
              <p className="syb-text">Each year, we need to set a balanced budget to deliver services. But with reduced funding and rising costs, our funds are shrinking. We've restructured, improved services, and generated more income, but we still need to save £28m next year.</p>
              <p>In our proposed budget we have set out plans to save £21m through service reductions and raise £7m by applying 2.99% Council Tax rise and 2% Adult Social Care precept as expected by government. This is our approach, what is yours?</p>
              <p>You can view the council’s <a href="https://www.newcastle.gov.uk/budget" target="_blank">draft budget proposals here</a>.</p>
            </Cell>
          </Grid>
        </div>

        <div className={classnames({ 'l-section-fixed-wrap': fixed })} ref={fixedSection => (this.fixedSection = fixedSection)}>
          <div className="l-container">
            <Notification
              heading={_news.headline}
              body={_news.text}
              isActive={_news && _news.show}
              handleClose={this.props.hideNewsAction}
              inFixedPostion={this.state.fixed}
            />
            <div className="l-section l-section--pt-0 syb-text-container">
              <Grid>
                <Cell size={{ desktop: '12', tablet: '6', phone: '6' }}>
                  <div className={classnames({ 'l-section-fixed-wrap-mobile': fixed })}>
                    <BudgetTotalBar
                      minLabel={`£0`}
                      maxLabel={`£28m`}
                      value={`£${(smallNumber(_budget.initial_total - _budget.current_total))}`}
                      widthValue={savingsTargetWidthValue}
                      isError={(_budget.initial_total - _budget.current_total) > 28000000}
                    >
                      <div className="text-center">
                        <h2 className="u-text-black c-total-bar-header__title">
                          <span className="c-total-bar-header__sub-title">Savings Target</span><br />
                          £28m
                        </h2>
                      </div>
                    </BudgetTotalBar>
                  </div>
                </Cell>
              </Grid>
            </div>
          </div>
        </div>

        <section className="l-section l-section--grey syb-l-section-income-areas">
          <div className="l-section__header">
            <h2 className="l-section__title">Income Areas</h2>
            <p className="l-section__sub-title">Help your budget by generating income</p>
          </div>
          <div className='spending-priorities council-tax'>
            <div className="c-range-input-header text-center syb-council-tax-container">
              <h2 className="u-text-black c-range-input-header__title">
                <span className="c-range-input-header__sub-title">Council Tax and Adult Social Care Precept</span><br />
                £{(smallNumber(_budget.council.value_tax))}
              </h2>

              <span className="c-range-input-header__info-trigger" onClick={() => this.toggleCouncilModal()}>
                <i className="fa fa-info-circle u-text-pink" />
              </span>
            </div>

            <RangeInput
              budget={_budget}
              disabled={this.props._budget.showBudgetSuccessModal || this.props._budget.showRefurendumModal}
              className={`c-range--purple ${this.props._budget.tooltipActive ? 'is-tooltip-active' : ''}`}
              tooltipValue={`${(_budget.council.value_tax / (_budget.council.max_tax / 10))}%`}
              changeHandler={(value) => {
                this.setState({
                  barColor: value / _budget.council.max_tax
                });
                changeCouncilBudgetAction(value);
              }}
            />
          </div>

          <IncomeAreasSection
            budget={_budget}
            changeCouncilCategoryAction={changeCouncilCategoryAction}
          />
        </section>

        <section className="l-section l-section--bordered-x-y" id="service-areas-section">
          <div className="l-section__header">
            <Grid>
              <Cell size={{ desktop: '12', tablet: '12', phone: '6' }}>
                <h2 className="l-section__title">Service Areas</h2>
                <p className="l-section__sub-title">
                  Help meet your target by creating savings in key areas
                </p>
              </Cell>
            </Grid>
          </div>

          <div style={{ position: 'relative' }}>
            <Grid>
              {
                (_budget && _budget.peoples_averages) &&
                _budget.spending_areas.map((area, key) => {
                  const potentialImpacts = this.getPotentialImpacts(area.triggers, area.value, area.max);

                  return (
                    <Cell size={{ desktop: '4', tablet: '6', phone: '6' }} key={key}>
                      <SpendingAreaCard
                        cons={potentialImpacts}
                        key={key}
                        color={area.color}
                        name={area.name}
                        description={area.description}
                        value={area.value}
                        max={area.max}
                        locked={area.locked}
                        info={area.info}
                        step={area.step}
                        icon={area.icon}
                        slug={area.slug}
                        disabled={!isIE11 && this.props._budget.showBudgetSuccessModal}
                        onChange={(e) => {
                          if (!this.props._budget.showBudgetSuccessModal) {
                            this.props.changeSpendingAreaAction(key, e.target.value, area.slug)
                          } else {
                            return;
                          }
                        }}
                        toggleInfo={this.toggleInfoCard}
                      />
                      {
                        (spendingAreaInfoBlocks[key] && spendingAreaInfoBlocks[key].isInfoCardActive) &&
                        <div className="c-info-block" style={{ backgroundColor: area.color }}>
                          <div className="c-info-block__header">
                            <i className="c-info-block__close fa fa-times" onClick={() => this.toggleInfoCard(area.slug, 'info')} />
                            <h2 className="c-info-block__title">{area.name} - <i className='fa fa-info-circle' /> Information</h2>
                          </div>

                          <div className="c-info-block__content">
                            <p>{area.info}</p>

                            {
                              area.table &&
                              <BudgetAreaTable data={area.table} />
                            }

                          </div>
                        </div>
                      }

                      {
                        (spendingAreaInfoBlocks[key] && spendingAreaInfoBlocks[key].isImpactsCardActive) &&
                        <div className="c-info-block" style={{ backgroundColor: area.color }}>
                          <div className="c-info-block__header">
                            <i className="c-info-block__close fa fa-times" onClick={() => this.toggleInfoCard(area.slug, 'impacts')} />
                            <h2 className="c-info-block__title">{area.name} - <i className='fas fa-exclamation-triangle' /> Potential Impacts</h2>
                          </div>

                          <div className="c-info-block__content">
                            {
                              potentialImpacts.length > 0 && potentialImpacts.map((item, k1) => {
                                return (
                                  <div key={k1} className='cons-list-item'>
                                    {
                                      item.consequences.length > 0 &&
                                      <b>{item.to === 999999999999 ? ('Reductions more than £' + smallNumber(item.from)) : 'Reductions up to £' + smallNumber(item.to)}</b>
                                    }

                                    <ul>
                                      {item.consequences.map((neCons, k) => {
                                        return <li key={k}>{neCons}</li>
                                      })}
                                    </ul>
                                  </div>
                                )
                              })
                            }
                          </div>
                        </div>
                      }
                    </Cell>
                  )
                }
                )
              }
            </Grid>
          </div>

          <Divide isLarge={true} isLight={true} />

          <Grid>
            <Cell size={{ desktop: '8', tablet: '8', phone: '6' }}>
              <div className="c-box c-box--capital">
                <div className="c-box__content">
                  <h2 className="c-box__title">
                    Capital Expenditure<br />
                    &pound;130m
                  </h2>
                  <div className="c-box__body--narrow">
                    <p>
                      Capital spending can only be used to build infrastructure, such as highways and new buildings. By law, we cannot use our capital budget to fund revenue expenditure on day to day services.
                    </p>
                    <p>The budget is locked</p>
                    <img className="c-box__range-image" src={lockedRangeInputImage} alt="Locked Range Input" />
                  </div>
                </div>
              </div>
            </Cell>

            <Cell size={{ desktop: '4', tablet: '4', phone: '6' }}>
              <div className="c-box c-box--full-height">
                <h2>Give up</h2>
                <div className="c-box__body">
                  <p>
                    Before you give up, can you tell us about why? Were there particular aspects you found harder than others? Is there a particular area you would want to prioritise?
                  </p>

                  <div className="c-form-control c-form-control--light">
                    <form id="give-up-form" onSubmit={(e) => {
                      e.preventDefault();
                      this.props.postGiveUpReason(
                        this.state.giveUpReason, () => {
                          this.setGiveUpStatus()
                        }
                      );
                    }}>
                      <textarea onChange={(e) => this.setGiveUpReason(e.target.value)} name="give_up_reason" />
                      <div className="c-form-control">
                        <button
                          className="c-button c-button--narrow"
                          disabled={this.state.giveUpReason.length < 5 || this.state.giveUpStatus}>
                          {this.state.giveUpStatus ? 'Thank You!' : 'Give up'}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </Cell>
          </Grid>
        </section>

        <Divide isLarge={true} isLight={true} />

        {
          _news.news_alerts.length > 0 &&
          <div>
            <section className="l-section">
              <h2>Budget Impact Summary</h2>
              <NewsItemSummary />
            </section>
            <Divide />
          </div>
        }

        <section className="l-section">
          <Grid>
            <Cell size={{ desktop: '12', tablet: '12', phone: '6' }}>
              <h2>Why did you set this budget?</h2>
              <p>We ask for these details to understand who joined the People's Budget. Your information is stored securely, won't be shared, and won't identify you. By providing your email address we can share what we have learned from the budget consultation.</p>
            </Cell>
          </Grid>

          <SubmitBudgetForm onSubmit={this.assignPayload} />
        </section>

        <Divide />

      </Secondary>
    )
  }
}

export default connect((state, ownProps) => {
  return {
    _budget: state.budget,
    _news: state.news
  }
}, (dispatch, ownProps) => {
  return {
    changeCouncilBudgetAction: (amount) => dispatch(budgetActions.changeCouncilBudgetAction(amount)),
    changeSpendingAreaAction: (key, value, slug) => dispatch(budgetActions.changeSpendingAreaAction(key, value, slug)),
    changeCouncilCategoryAction: (category, value) => dispatch(budgetActions.changeCouncilCategoryAction(category, value)),
    nav: (id) => dispatch(push('/bring-money-to-council')),
    hideNewsAction: () => dispatch(newsActions.hideNewsAction()),
    hideCongratulations: () => dispatch(newsActions.hideCongratulations()),
    hideBudgetSuccessModal: () => dispatch(budgetActions.hideBudgetSuccessModal()),
    showBudgetSuccessModalAction: (showButton) => dispatch(budgetActions.showBudgetSuccessModal(showButton)),
    showBudgetFailureModalAction: (showButton) => dispatch(budgetActions.showBudgetFailureModal()),
    hideBudgetFailureModal: () => dispatch(budgetActions.hideBudgetFailureModal()),
    saveAction: (payload) => dispatch(budgetActions.saveAction(payload)),
    triggerSubmitModal: () => dispatch(budgetActions.triggerSubmitModal()),
    toggleRefurendumModal: () => dispatch(budgetActions.toggleRefurendumModal()),
    logUserStartingAction: () => dispatch(budgetActions.logUserStartingAction()),
    postGiveUpReason: (reason, cb) => dispatch(budgetActions.postGiveUpReason(reason, cb)),
  }
})(SetYourBudget)



// WEBPACK FOOTER //
// ./src/pages/set-your-budget/SetYourBudget.jsx